import { render, staticRenderFns } from "./CommunicationForm.vue?vue&type=template&id=b390cafa"
import script from "./CommunicationForm.vue?vue&type=script&lang=js"
export * from "./CommunicationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports